import React, { useEffect } from 'react';
import SEO from '../components/SEO';
import { captureAttribution } from '../utils/leadTracking';
import Navbar from '../components/sections/Navbar';
import Hero from '../components/sections/Hero';
import ServicesGrid from '../components/sections/ServicesGrid';
import InsideOut from '../components/sections/InsideOut';
import InspirationGallery from '../components/sections/InspirationGallery';
import OutdoorLiving from '../components/sections/OutdoorLiving';
import Permitting from '../components/sections/Permitting';
import AIVisualizer from '../components/sections/AIVisualizer';
import HomeConceptGallery from '../components/sections/HomeConceptGallery';
import TechPromo from '../components/sections/TechPromo';
import HowItWorks from '../components/sections/HowItWorks';
import CompletedProjects from '../components/sections/CompletedProjects';
import WhyUs from '../components/sections/WhyUs';
import ServiceAreas from '../components/sections/ServiceAreas';
import LeadForm from '../components/sections/LeadForm';
import EmergencySection from '../components/sections/EmergencySection';
import EmergencyQuickButton from '../components/sections/EmergencyQuickButton';
import WhatsAppFloat from '../components/sections/WhatsAppFloat';
import Footer from '../components/sections/Footer';

export default function HomePage() {
  useEffect(() => { captureAttribution(); }, []);
  return (
    <>
      <SEO
        path="/"
        title="Dviso Construction | Construction, Remodeling & Project Management in Miami"
        description="Dviso Construction provides construction, remodeling, project management, permitting coordination and multitrade construction services throughout Miami and Miami-Dade County."
      />
      <Navbar />
      <main>
        <Hero />
        <ServicesGrid />
        <InsideOut />
        <InspirationGallery />
        <OutdoorLiving />
        <Permitting />
        <AIVisualizer />
        <HomeConceptGallery />
        <TechPromo />
        <HowItWorks />
        <CompletedProjects />
        <WhyUs />
        <ServiceAreas />
        <LeadForm />
        <EmergencySection />
      </main>
      <Footer />
      <EmergencyQuickButton />
      <WhatsAppFloat />
    </>
  );
}
